import Mutations from '../../odata/mutations';

export default { ...new Mutations('keywordHistoryResult'), ...new Mutations('keywordHistoryResults') };
